import Layout from '@/layout';
import { setTitle } from '@/utils/siteTitle';

export default {
  path: '/redirect',
  redirect: to => {
    const { username, password, systemFlag } = to.query;
    // 设置系统标题
    setTitle(systemFlag);

    if (username && password) {
      return {
        path: '/login',
        query: { username, password }
      };
    }
    return { path: '/' };
  },
  component: Layout,
  meta: {
    title: '重定向'
  }
};
